import { render, staticRenderFns } from "./createFactory.vue?vue&type=template&id=633714b9&scoped=true&"
import script from "./createFactory.vue?vue&type=script&lang=js&"
export * from "./createFactory.vue?vue&type=script&lang=js&"
import style0 from "./createFactory.vue?vue&type=style&index=0&id=633714b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633714b9",
  null
  
)

export default component.exports